const types = [
    {
        name: 'Job Sheet',
        value: 'handover',
    },
    {
        name: 'Fire Alarm Test',
        value: 'fire_alarm_test_2',
        category: 'fire_alarm',
    },
    {
        name: 'Domestic Fire Alarm Service',
        value: 'domestic_fire_alarm_service',
        category: 'fire_alarm',
    },
    {
        name: 'Fire Alarm Variations',
        value: 'fire_alarm_variations',
        category: 'fire_alarm',
    },
    {
        name: 'Fire Alarm Commissioning',
        value: 'fire_alarm_commissioning',
        category: 'fire_alarm',
    },
    {
        name: 'Fire Door Inspection',
        value: 'fire_door_inspection',
    },
    {
        name: 'Take Over',
        value: 'take_over',
        category: 'fire_alarm',
    },
    {
        name: 'Fire Alarm Certificate',
        value: 'fire_alarm_certificate',
        hideFromEngineer: true,
        category: 'fire_alarm',
    },
    {
        name: 'Fire Alarm Commissioning Certificate',
        value: 'fire_alarm_commissioning_certificate',
        hideFromEngineer: true,
        category: 'fire_alarm',
    },
    {
        name: 'E-Lighting Form',
        value: 'elighting',
    },
    {
        name: 'E-Lighting Certificate',
        value: 'elighting_certificate',
        hideFromEngineer: true,
    },
    {
        name: 'Fire Ex Service Form',
        value: 'fire_ex_service',
    },
    {
        name: 'Fire Ex Certificate',
        value: 'fire_ex_certificate',
        hideFromEngineer: true,
    },
    {
        name: 'Audit Report',
        value: 'aldi',
    },
    {
        name: 'Recommendations/Quotation',
        value: 'recommendations',
    },
    {
        name: 'Elliotts ZF Form',
        value: 'zf_form',
    },
    {
        name: 'Intruder Alarm Service Report / Certificate',
        value: 'intruder_alarm_service',
    },
    {
        name: 'Fire Training',
        value: 'fire_training',
    },
    {
        name: 'Fire Risk Assessment',
        value: 'fire_risk_assessment',
    },
    {
        name: 'Nurse Call System Service Report / Certificate',
        value: 'nurse_call',
    },
];

const fire_alarm_systems = [
    'L1',
    'L2',
    'L3',
    'L4',
    'M',
    'P1',
    'P2',
];

export {
    types,
    fire_alarm_systems,
}


// WEBPACK FOOTER //
// ./resources/assets/js/include/Form.js